import React, { useState } from 'react';
import { portfolio } from '../../models/content';

function PortfolioAccordionItem({ doc, isOpen, onToggle }) {
  return (
    <article className={`portfolio-accordion ${isOpen ? 'is-open' : ''}`}>
      <button
        type="button"
        className="portfolio-accordion-header"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="portfolio-accordion-title">{doc.title}</span>
        <span className="portfolio-accordion-icon" aria-hidden="true">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      {isOpen ? (
        <div className="portfolio-accordion-body">
          <p>{doc.description}</p>
        </div>
      ) : null}
    </article>
  );
}

export default function V2PortfolioPage() {
  const [openTitle, setOpenTitle] = useState(null);

  const toggleDoc = (title) => {
    setOpenTitle((current) => (current === title ? null : title));
  };

  return (
    <main>
      <section className="page-hero">
        <div className="wrap">
          <span className="v2-badge">
            <span className="dot" />
            {portfolio.heroBadge}
          </span>
          <h1>
            {portfolio.heroTitle.map((p, i) =>
              typeof p === 'string' ? (
                <React.Fragment key={i}>{p}</React.Fragment>
              ) : (
                <span key={i} className="it">
                  {p.it}
                </span>
              )
            )}
          </h1>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="portfolio-accordion-list">
            {portfolio.docs.map((d) => (
              <PortfolioAccordionItem
                key={d.title}
                doc={d}
                isOpen={openTitle === d.title}
                onToggle={() => toggleDoc(d.title)}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
